export enum EChannel {
  redirecting = "redirecting",
  showcase = "showcase",
  sms = "sms",
  whatsapp = "whatsapp",
  stamp = "stamp", // Tampon
  demo = "demo", // Demo
}

export const channelAsString = (
  channel: EChannel
): string => {
  switch (channel) {
    case EChannel.redirecting:
      return "Redirection";
    case EChannel.showcase:
      return "Vitrine";
    case EChannel.sms:
      return "SMS";
    case EChannel.whatsapp:
      return "WhatsApp";
    case EChannel.stamp:
      return "Tampon";
    case EChannel.demo:
      return "Demo";
    default:
      return "";
  }
};
